import type { OnDestroy } from '@angular/core';
import { inject, Injectable, signal } from '@angular/core';

import type { EWebSocketMessage } from '@rpgc-ai/shared-interfaces/enums/websocket.enum';

import { WebSocketConnectionManager } from './websocket-connection-manager.service';

@Injectable({
  providedIn: 'root',
})
export abstract class WebsocketService<T> implements OnDestroy {
  readonly #manager = inject(WebSocketConnectionManager);

  #unsubscribe: (() => void) | null = null;

  message = signal<T | null>(null);

  protected abstract readonly eventKey: EWebSocketMessage;

  ngOnDestroy(): void {
    this.disconnect();
    this.message.set(null);
  }

  connect(): void {
    if (this.#unsubscribe) {
      return;
    }

    this.#unsubscribe = this.#manager.subscribe(this.eventKey, (data) => {
      this.message.set(data as T);
    });

    this.#manager.connect();
  }

  disconnect(): void {
    if (!this.#unsubscribe) {
      return;
    }

    this.#unsubscribe();
    this.#unsubscribe = null;
    this.#manager.disconnect();
    this.message.set(null);
  }
}
